// src/api/evenements-api.js
import { gql } from '@apollo/client';
import client from './apollo-client';

// GraphQL Queries
export const GET_EVENEMENTS = gql`
  query GetEvenements {
    evenements {
      id
      date
      location
      conclusions
      reminderAlert
      comment
      attachments
      associationId
      laboratoryId
      association {
        id
        nomAssociation
        adresse
        nomContact
        prenomContact
        telContact
      }
      laboratory {
        id
        nom
      }
      products {
        id
        name
        description
        price
        image
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_EVENEMENT = gql`
  query GetEvenement($id: ID!) {
    evenement(id: $id) {
      id
      date
      location
      conclusions
      reminderAlert
      comment
      attachments
      associationId
      laboratoryId
      association {
        id
        nomAssociation
        adresse
        nomContact
        prenomContact
        telContact
      }
      laboratory {
        id
        nom
      }
      products {
        id
        name
        description
        price
        image
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_ASSOCIATIONS = gql`
  query GetAssociations {
    associations {
      id
      nomAssociation
      adresse
      nomContact
      prenomContact
      telContact
      createdAt
      updatedAt
    }
  }
`;

export const GET_LABORATORIES_FOR_EVENTS = gql`
  query GetLaboratoriesForEvents {
    laboratories {
      id
      nom
      products {
        id
        name
        price
        description
        image
      }
      createdAt
      updatedAt
    }
  }
`;

// GraphQL Mutations
export const CREATE_EVENEMENT = gql`
  mutation CreateEvenement($createEvenementInput: CreateEvenementInput!) {
    createEvenement(createEvenementInput: $createEvenementInput) {
      id
      date
      location
      conclusions
      reminderAlert
      comment
      attachments
      associationId
      laboratoryId
      association {
        id
        nomAssociation
      }
      laboratory {
        id
        nom
      }
    }
  }
`;

export const UPDATE_EVENEMENT = gql`
  mutation UpdateEvenement($updateEvenementInput: UpdateEvenementInput!) {
    updateEvenement(updateEvenementInput: $updateEvenementInput) {
      id
      date
      location
      conclusions
      reminderAlert
      comment
      attachments
      associationId
      laboratoryId
      association {
        id
        nomAssociation
      }
      laboratory {
        id
        nom
      }
    }
  }
`;

export const DELETE_EVENEMENT = gql`
  mutation DeleteEvenement($id: ID!) {
    removeEvenement(id: $id)
  }
`;

// Evenements API functions
export const evenementsApi = {
  getEvenements: async () => {
    try {
      const { data } = await client.query({
        query: GET_EVENEMENTS,
        fetchPolicy: 'network-only'
      });
      return data.evenements;
    } catch (error) {
      console.error('Get evenements error:', error);
      throw error;
    }
  },

  getEvenement: async (id) => {
    try {
      const { data } = await client.query({
        query: GET_EVENEMENT,
        variables: { id },
        fetchPolicy: 'network-only'
      });
      return data.evenement;
    } catch (error) {
      console.error(`Get evenement ${id} error:`, error);
      throw error;
    }
  },

  getAssociations: async () => {
    try {
      const { data } = await client.query({
        query: GET_ASSOCIATIONS,
        fetchPolicy: 'network-only'
      });
      return data.associations;
    } catch (error) {
      console.error('Get associations error:', error);
      throw error;
    }
  },

  getLaboratories: async () => {
    try {
      const { data } = await client.query({
        query: GET_LABORATORIES_FOR_EVENTS,
        fetchPolicy: 'network-only'
      });
      return data.laboratories;
    } catch (error) {
      console.error('Get laboratories error:', error);
      throw error;
    }
  },

  createEvenement: async (evenementData) => {
    try {
      const { data } = await client.mutate({
        mutation: CREATE_EVENEMENT,
        variables: { createEvenementInput: evenementData },
        refetchQueries: [{ query: GET_EVENEMENTS }]
      });
      return data.createEvenement;
    } catch (error) {
      console.error('Create evenement error:', error);
      throw error;
    }
  },

  updateEvenement: async (evenementData) => {
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_EVENEMENT,
        variables: { updateEvenementInput: evenementData },
        refetchQueries: [{ query: GET_EVENEMENTS }]
      });
      return data.updateEvenement;
    } catch (error) {
      console.error(`Update evenement ${evenementData.id} error:`, error);
      throw error;
    }
  },

  deleteEvenement: async (id) => {
    try {
      const { data } = await client.mutate({
        mutation: DELETE_EVENEMENT,
        variables: { id },
        refetchQueries: [{ query: GET_EVENEMENTS }]
      });
      return data.removeEvenement;
    } catch (error) {
      console.error(`Delete evenement ${id} error:`, error);
      throw error;
    }
  }
};